import { cn } from "@/lib/utils"

type Tone = "info" | "warning" | "success" | "danger"

const toneStyles: Record<Tone, string> = {
  info: "bg-sky-500",
  warning: "bg-amber-500",
  success: "bg-emerald-500",
  danger: "bg-red-500",
}

interface ProgressBarProps {
  value: number
  tone?: Tone
  className?: string
}

export function ProgressBar({ value, tone = "info", className }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value))
  return (
    <div className={cn("bg-muted h-1.5 w-full overflow-hidden rounded-full", className)}>
      <div
        className={cn("h-full rounded-full transition-all", toneStyles[tone])}
        style={{ width: `${clamped}%` }}
      />
    </div>
  )
}
